import { Stack } from '@mui/material';
import { ReactNode } from 'react';

// PCレイアウトだと２分割・スマホレイアウトだと２段にするコンポートネント
export const ResponsiveTwoSplit = (props: {
  cellA: ReactNode;
  cellB: ReactNode;
}) => (
  <Stack
    width={1}
    direction={{
      sm: 'column',
      md: 'row',
    }}
    spacing={2}
    justifyContent="space-between"
  >
    <Stack>{props.cellA}</Stack>
    <Stack>{props.cellB}</Stack>
  </Stack>
);
